import { Redirect } from '@shopify/app-bridge/actions';
import { getSABAppInstance_Normal, isByPassScript } from './app';
import { isSafeUrl } from 'src/helpers';

let SABRedirectInstance = null;

function createSABRedirectInstance() {
    const app = getSABAppInstance_Normal();
    SABRedirectInstance = Redirect.create(app);
}

export const shopifyRedirect = (url) => {
    // Validate before navigating anyway so a javascript:/data: URL can never reach
    // Redirect.Action.REMOTE or window.open(), regardless of what the caller passed in.
    if (!isSafeUrl(url)) {
        return;
    }

    if (isByPassScript()) {
        if (!SABRedirectInstance) {
            createSABRedirectInstance();
        }
        SABRedirectInstance.dispatch(Redirect.Action.REMOTE, url);
        return
    }

    window.open(url, '_top', 'noopener,noreferrer');
};

export const shopifyRedirectAdmin = (url) => {
    if (!SABRedirectInstance) {
        createSABRedirectInstance();
    }
    SABRedirectInstance.dispatch(Redirect.Action.ADMIN_PATH, {
        path: url,
        newContext: true,
    });
};